import { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/useLanguage';
import logoImg from '../../assets/readdy/60ff3a18dd5605b1f76c7856e3032bde__dd3962c993.png';
import showcaseMainImg from '../../assets/readdy/6f3f8af469c6fb1296840e314945b880__7ce38ddc5b.png';
import showcaseChatImg from '../../assets/readdy/40842699bb936e336f270797901ea75d__2e03bcd231.png';
import showcaseDetailImg from '../../assets/readdy/cc48b5cd7be83b3a50347eb5ba3afa03__33c13327db.png';
import feature1Img from '../../assets/readdy/b89ba225015c4c81f33f0d3172aaa7fb__fecd0a0db4.jpeg';
import feature2Img from '../../assets/readdy/cefd16343c7e5e97dd67f281e7f15498__a62ccbb385.jpeg';
import feature3Img from '../../assets/readdy/ded5ed8c7264aa4bb2cc8c6fb826925d__4dd2fa6957.jpeg';

export default function EmotionalAiPage() {
  const [scrolled, setScrolled] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const content = {
    zh: {
      home: '首页',
      aiComic: 'AI漫画',
      emotionalAi: '情感AI',
      heroBadge: '情感AI · 智能陪伴',
      heroTitle: '重新定义情感交互',
      heroDesc: '基于先进的AI技术，打造懂你的智能陪伴体验，让每一次对话都充满温度',
      showcaseTitle: '可爱又聪明的AI伙伴',
      showcaseDesc: '每一个都有独特的性格和情感表达，用最温暖的方式陪伴你的每一天',
      realtimeInteraction: '实时互动',
      feature1Title: '情感识别',
      feature1Desc: '通过先进的AI算法，精准识别并回应你的情绪变化，提供最贴心的陪伴体验',
      feature2Title: '智能对话',
      feature2Desc: '自然流畅的对话体验，记住你们之间的每一个重要时刻，越聊越懂你',
      feature3Title: '个性定制',
      feature3Desc: '多种性格选择，每一个都有独特的外观和性格特点，找到最适合你的那一个',
      section1Badge: '智能对话',
      section1Title: '自然流畅的\n情感交流体验',
      section1Desc: '采用最新的自然语言处理技术，理解你的情绪变化，提供贴心的回应。无论是日常闲聊还是深度交流，都能给你最温暖的陪伴。',
      section1Item1Title: '情绪识别',
      section1Item1Desc: '精准捕捉对话中的情感信号',
      section1Item2Title: '个性化回应',
      section1Item2Desc: '根据你的性格特点定制对话风格',
      section1Item3Title: '记忆功能',
      section1Item3Desc: '记住你们之间的每一个重要时刻',
      section2Badge: '多场景支持',
      section2Title: '适配你的\n每一个生活场景',
      section2Desc: '从工作助手到生活伙伴，从学习辅导到情感倾诉，我们的AI能够无缝切换不同角色，满足你在各种场景下的需求。',
      section2Item1Title: '工作助手',
      section2Item1Desc: '提升效率的智能伙伴',
      section2Item2Title: '情感陪伴',
      section2Item2Desc: '温暖贴心的倾听者',
      section2Item3Title: '学习辅导',
      section2Item3Desc: '耐心专业的导师',
      section2Item4Title: '娱乐互动',
      section2Item4Desc: '有趣好玩的玩伴',
      section3Badge: '个性定制',
      section3Title: '打造专属于你的\nAI伙伴',
      section3Desc: '通过深度学习和持续优化，AI会逐渐了解你的喜好、习惯和性格特点，成为真正懂你的专属伙伴。',
      personalityMatch: '性格匹配度',
      conversationSatisfaction: '对话满意度',
      intelligentUnderstanding: '智能理解力',
      ctaTitle: '开启你的情感AI之旅',
      ctaDesc: '让AI成为你生活中最懂你的伙伴，体验前所未有的智能陪伴',
      ctaButton: '立即体验',
      footerDesc: '融合AI技术与东方文化，打造新一代数字内容创作与情感交互平台',
      footerProducts: '产品',
      footerProduct1: 'AI漫画生成器',
      footerProduct2: 'AI治愈萌宠',
      footerCompany: '公司',
      footerAbout: '关于我们',
      footerTeam: '团队介绍',
      footerVision: '企业愿景',
      footerContact: '联系我们',
      footerHkOffice: '香港办公室：',
      footerHkAddress: '香港九龙观塘开源道62号骆驼漆大厦一座18楼A室',
      footerSzOffice: '深圳办公室：',
      footerSzAddress: '深圳市南山区粤海街道科技园社区科苑路15号科兴科学园B栋3单元',
      footerEmail: '邮箱：',
      footerPhone: '电话：',
      footerCopyright: '© 2025 可画科技. All rights reserved.',
      footerPrivacy: '隐私政策',
      footerTerms: '服务条款',
      footerPowered: 'Powered by Readdy'
    },
    en: {
      home: 'Home',
      aiComic: 'AI Comic',
      emotionalAi: 'Emotional AI',
      heroBadge: 'Emotional AI · Smart Companion',
      heroTitle: 'Redefining Emotional Interaction',
      heroDesc: 'Based on advanced AI technology, create an intelligent companion experience that understands you, making every conversation warm',
      showcaseTitle: 'Cute and Smart AI Partners',
      showcaseDesc: 'Each with unique personality and emotional expression, accompanying you every day in the warmest way',
      realtimeInteraction: 'Real-time Interaction',
      feature1Title: 'Emotion Recognition',
      feature1Desc: 'Through advanced AI algorithms, accurately identify and respond to your emotional changes, providing the most caring companionship',
      feature2Title: 'Smart Conversation',
      feature2Desc: 'Natural and smooth conversation experience, remembering every important moment between you, understanding you better',
      feature3Title: 'Personalization',
      feature3Desc: 'Multiple personality options, each with unique appearance and personality traits, find the one that suits you best',
      section1Badge: 'Smart Conversation',
      section1Title: 'Natural and Smooth\nEmotional Communication',
      section1Desc: 'Using the latest natural language processing technology to understand your emotional changes and provide caring responses. Whether daily chat or deep communication, it can give you the warmest companionship.',
      section1Item1Title: 'Emotion Recognition',
      section1Item1Desc: 'Accurately capture emotional signals in conversations',
      section1Item2Title: 'Personalized Response',
      section1Item2Desc: 'Customize conversation style based on your personality',
      section1Item3Title: 'Memory Function',
      section1Item3Desc: 'Remember every important moment between you',
      section2Badge: 'Multi-scenario Support',
      section2Title: 'Adapt to Every\nLife Scenario',
      section2Desc: 'From work assistant to life partner, from learning tutor to emotional confidant, our AI can seamlessly switch between different roles to meet your needs in various scenarios.',
      section2Item1Title: 'Work Assistant',
      section2Item1Desc: 'Smart partner for efficiency',
      section2Item2Title: 'Emotional Companion',
      section2Item2Desc: 'Warm and caring listener',
      section2Item3Title: 'Learning Tutor',
      section2Item3Desc: 'Patient and professional mentor',
      section2Item4Title: 'Entertainment',
      section2Item4Desc: 'Fun and playful companion',
      section3Badge: 'Personalization',
      section3Title: 'Create Your Own\nAI Partner',
      section3Desc: 'Through deep learning and continuous optimization, AI will gradually understand your preferences, habits and personality traits, becoming a truly understanding exclusive partner.',
      personalityMatch: 'Personality Match',
      conversationSatisfaction: 'Conversation Satisfaction',
      intelligentUnderstanding: 'Intelligent Understanding',
      ctaTitle: 'Start Your Emotional AI Journey',
      ctaDesc: 'Let AI become the most understanding partner in your life, experience unprecedented intelligent companionship',
      ctaButton: 'Try Now',
      footerDesc: 'Integrating AI technology with Eastern culture to create a new generation of digital content creation and emotional interaction platform',
      footerProducts: 'Products',
      footerProduct1: 'AI Comic Generator',
      footerProduct2: 'AI Healing Pet',
      footerCompany: 'Company',
      footerAbout: 'About Us',
      footerTeam: 'Team',
      footerVision: 'Vision',
      footerContact: 'Contact Us',
      footerHkOffice: 'Hong Kong Office:',
      footerHkAddress: 'Room A, 18/F, Tower 1, Camel Paint Building, 62 Hoi Yuen Road, Kwun Tong, Kowloon, Hong Kong',
      footerSzOffice: 'Shenzhen Office:',
      footerSzAddress: 'Unit 3, Building B, Kexing Science Park, No. 15 Keyuan Road, Science Park Community, Yuehai Street, Nanshan District, Shenzhen',
      footerEmail: 'Email:',
      footerPhone: 'Phone:',
      footerCopyright: '© 2025 ComiAI Technology. All rights reserved.',
      footerPrivacy: 'Privacy Policy',
      footerTerms: 'Terms of Service',
      footerPowered: 'Powered by Readdy'
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 via-white to-gray-50">
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center cursor-pointer">
            <img 
              src={logoImg}
              alt="可画科技"
              className="h-10 w-auto"
            />
          </a>
          <div className="flex items-center space-x-8">
            <a href="/" className="text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">{t.home}</a>
            <a href="/aicomic" className="text-sm text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">{t.aiComic}</a>
            <a href="/emotional-ai" className="text-sm text-gray-900 font-medium cursor-pointer">{t.emotionalAi}</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-purple-100 px-6 py-2 rounded-full mb-6">
            <div className="w-2 h-2 bg-pink-500 rounded-full animate-pulse"></div>
            <span className="text-sm font-medium text-gray-700">{t.heroBadge}</span>
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {t.heroTitle}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.heroDesc}
          </p>
        </div>
      </section>

      {/* Product Showcase Section */}
      <section className="py-24 px-6 bg-gradient-to-br from-pink-50 via-white to-purple-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {t.showcaseTitle}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              {t.showcaseDesc}
            </p>
          </div>

          <div className="relative">
            <div className="max-w-6xl mx-auto mb-12">
              <div className="grid md:grid-cols-5 gap-8 items-center">
                <div className="relative md:col-span-3">
                  <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-pink-50 to-purple-50 p-8 shadow-xl">
                    <img
                      src={showcaseMainImg}
                      alt="情感AI智能伙伴"
                      className="w-full h-auto object-contain"
                    />
                  </div>
                  <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gradient-to-br from-pink-300 to-purple-300 rounded-full blur-3xl opacity-30"></div>
                </div>

                <div className="relative md:col-span-2 md:translate-y-8">
                  <div className="relative">
                    <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white z-10">
                      <img
                        src={showcaseChatImg}
                        alt="智能对话界面"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                    
                    <div className="absolute -bottom-16 -right-12 w-56 h-56 rounded-2xl overflow-hidden shadow-xl border-3 border-white z-20 transform rotate-6 hover:rotate-0 transition-transform duration-300">
                      <img
                        src={showcaseDetailImg}
                        alt="情感互动细节"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  
                  <div className="absolute -top-4 -left-4 w-24 h-24 bg-gradient-to-br from-purple-300 to-pink-300 rounded-full blur-2xl opacity-40"></div>
                  
                  <div className="absolute top-8 -right-4 bg-white rounded-2xl shadow-lg px-6 py-3 border border-gray-100 z-30">
                    <div className="flex items-center space-x-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-sm font-medium text-gray-700">{t.realtimeInteraction}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-pink-400 to-pink-600 rounded-2xl mb-6">
                  <i className="ri-emotion-happy-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{t.feature1Title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {t.feature1Desc}
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-purple-400 to-purple-600 rounded-2xl mb-6">
                  <i className="ri-chat-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{t.feature2Title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {t.feature2Desc}
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl mb-6">
                  <i className="ri-palette-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{t.feature3Title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {t.feature3Desc}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature 1 */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 space-y-6">
              <div className="inline-block">
                <span className="text-xs font-semibold text-pink-600 bg-pink-50 px-4 py-2 rounded-full tracking-wider uppercase">{t.section1Badge}</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 leading-tight whitespace-pre-line">
                {t.section1Title}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t.section1Desc}
              </p>
              <div className="space-y-4 pt-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-pink-100 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-pink-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t.section1Item1Title}</h4>
                    <p className="text-sm text-gray-600">{t.section1Item1Desc}</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-pink-100 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-pink-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t.section1Item2Title}</h4>
                    <p className="text-sm text-gray-600">{t.section1Item2Desc}</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-pink-100 rounded-lg flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-pink-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">{t.section1Item3Title}</h4>
                    <p className="text-sm text-gray-600">{t.section1Item3Desc}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={feature1Img}
                  alt="智能对话界面"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-pink-500/10 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature 2 */}
      <section className="py-16 px-6 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={feature2Img}
                alt="多场景应用"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-500/10 to-transparent"></div>
            </div>
            <div className="space-y-6">
              <div className="inline-block">
                <span className="text-xs font-semibold text-purple-600 bg-purple-50 px-4 py-2 rounded-full tracking-wider uppercase">{t.section2Badge}</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 leading-tight whitespace-pre-line">
                {t.section2Title}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t.section2Desc}
              </p>
              <div className="grid grid-cols-2 gap-4 pt-4">
                <div className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-xl mb-3">
                    <i className="ri-briefcase-line text-2xl text-purple-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t.section2Item1Title}</h4>
                  <p className="text-xs text-gray-600">{t.section2Item1Desc}</p>
                </div>
                <div className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-xl mb-3">
                    <i className="ri-heart-line text-2xl text-pink-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t.section2Item2Title}</h4>
                  <p className="text-xs text-gray-600">{t.section2Item2Desc}</p>
                </div>
                <div className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl mb-3">
                    <i className="ri-book-open-line text-2xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t.section2Item3Title}</h4>
                  <p className="text-xs text-gray-600">{t.section2Item3Desc}</p>
                </div>
                <div className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow">
                  <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-xl mb-3">
                    <i className="ri-gamepad-line text-2xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-1">{t.section2Item4Title}</h4>
                  <p className="text-xs text-gray-600">{t.section2Item4Desc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature 3 */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 space-y-6">
              <div className="inline-block">
                <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-4 py-2 rounded-full tracking-wider uppercase">{t.section3Badge}</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 leading-tight whitespace-pre-line">
                {t.section3Title}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t.section3Desc}
              </p>
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0">
                    <i className="ri-user-heart-line text-xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium text-gray-700">{t.personalityMatch}</span>
                      <span className="text-sm font-bold text-blue-600">95%</span>
                    </div>
                    <div className="w-full bg-blue-200 rounded-full h-2">
                      <div className="bg-blue-600 h-2 rounded-full" style={{ width: '95%' }}></div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-500 rounded-full flex-shrink-0">
                    <i className="ri-chat-smile-3-line text-xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium text-gray-700">{t.conversationSatisfaction}</span>
                      <span className="text-sm font-bold text-cyan-600">98%</span>
                    </div>
                    <div className="w-full bg-cyan-200 rounded-full h-2">
                      <div className="bg-cyan-600 h-2 rounded-full" style={{ width: '98%' }}></div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-purple-500 rounded-full flex-shrink-0">
                    <i className="ri-brain-line text-xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-medium text-gray-700">{t.intelligentUnderstanding}</span>
                      <span className="text-sm font-bold text-purple-600">92%</span>
                    </div>
                    <div className="w-full bg-purple-200 rounded-full h-2">
                      <div className="bg-purple-600 h-2 rounded-full" style={{ width: '92%' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={feature3Img}
                  alt="个性化定制"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-500/10 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            {t.ctaTitle}
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            {t.ctaDesc}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/coming-soon')}
              className="px-10 py-4 bg-white text-purple-600 text-base font-semibold rounded-full hover:bg-gray-50 hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              {t.ctaButton}
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative py-16 bg-white overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <img
                  src={logoImg}
                  alt="ComiAI Logo"
                  className="h-12 w-auto"
                />
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-6">
                {t.footerDesc}
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-purple-100 text-purple-600 rounded-full hover:bg-purple-600 hover:text-white transition-all cursor-pointer">
                  <i className="ri-twitter-x-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-purple-100 text-purple-600 rounded-full hover:bg-purple-600 hover:text-white transition-all cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-purple-100 text-purple-600 rounded-full hover:bg-purple-600 hover:text-white transition-all cursor-pointer">
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-gray-900 font-semibold text-base mb-6">{t.footerProducts}</h4>
              <ul className="space-y-3">
                <li>
                  <a href="/aicomic" className="text-gray-600 hover:text-purple-600 transition-colors text-sm cursor-pointer">
                    {t.footerProduct1}
                  </a>
                </li>
                <li>
                  <a href="/emotional-ai" className="text-gray-600 hover:text-purple-600 transition-colors text-sm cursor-pointer">
                    {t.footerProduct2}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-gray-900 font-semibold text-base mb-6">{t.footerCompany}</h4>
              <ul className="space-y-3">
                <li>
                  <a 
                    onClick={() => {
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        document.getElementById('overview')?.scrollIntoView({ behavior: 'smooth' });
                      }, 100);
                    }}
                    className="text-gray-600 hover:text-purple-600 transition-colors text-sm cursor-pointer"
                  >
                    {t.footerAbout}
                  </a>
                </li>
                <li>
                  <a 
                    onClick={() => {
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        document.getElementById('team')?.scrollIntoView({ behavior: 'smooth' });
                      }, 100);
                    }}
                    className="text-gray-600 hover:text-purple-600 transition-colors text-sm cursor-pointer"
                  >
                    {t.footerTeam}
                  </a>
                </li>
                <li>
                  <a 
                    onClick={() => {
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        document.getElementById('vision')?.scrollIntoView({ behavior: 'smooth' });
                      }, 100);
                    }}
                    className="text-gray-600 hover:text-purple-600 transition-colors text-sm cursor-pointer"
                  >
                    {t.footerVision}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-gray-900 font-semibold text-base mb-6">{t.footerContact}</h4>
              <ul className="space-y-3 text-sm">
                <li className="text-gray-600">
                  <strong className="text-gray-900">{t.footerHkOffice}</strong><br />
                  {t.footerHkAddress}
                </li>
                <li className="text-gray-600">
                  <strong className="text-gray-900">{t.footerSzOffice}</strong><br />
                  {t.footerSzAddress}
                </li>
                <li className="text-gray-600">
                  <strong className="text-gray-900">{t.footerEmail}</strong><br />
                  comiai_talent@outlook.com
                </li>
                <li className="text-gray-600">
                  <strong className="text-gray-900">{t.footerPhone}</strong><br />
                  +852 5746 9338
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-600 text-sm">
                {t.footerCopyright}
              </p>
              <div className="flex space-x-6 text-sm">
                <a href="#" className="text-gray-600 hover:text-purple-600 transition-colors cursor-pointer">
                  {t.footerPrivacy}
                </a>
                <a href="#" className="text-gray-600 hover:text-purple-600 transition-colors cursor-pointer">
                  {t.footerTerms}
                </a>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-purple-600 transition-colors cursor-pointer">
                  {t.footerPowered}
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
